var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef, useState } from 'react';
import './columnHeader.scss';
import { faCircleInfo, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { AonCheckbox } from '../../../components/core/AonCheckbox';
import { AonTooltip } from '../../../components/core/AonTooltip';
import { useClientPageStore, useErrorStore } from '../../../store';
import { getApplicationConfig } from '../../../constants/utilities';
import { checkmarketSubscription, enableMarketFavorite, enableMarketNews } from '../../../api/marketData/apiSubscribedEntities';
import { UuiFlexlayout } from '@aonunited/react';
var ColumnTitle;
(function (ColumnTitle) {
    //common
    ColumnTitle["Favorite"] = "Favorite";
    ColumnTitle["News_subscription"] = "News Subscription";
    ColumnTitle["Name_and_Group"] = "Name & Group";
    ColumnTitle["Domiciled_Country"] = "Domiciled Country";
    ColumnTitle["MARKET_TYPE"] = "Market Type";
    //second option
    ColumnTitle["Aon_ID"] = "Aon ID";
    ColumnTitle["AM_Best_Rating_and_Outlook"] = "AM Best Rating & Outlook";
    ColumnTitle["S_and_P_Rating_and_Outlook"] = "S&P Rating & Outlook";
    ColumnTitle["Additional_Rating_Information"] = "Additional Rating Information";
    ColumnTitle["PHS_ASHF_C_and_S_Capacity_AuM_USDmn"] = "PHS/ASHF/C&S/Capacity/AuM (USDmn)";
    ColumnTitle["PHS_ASHF_C_and_S_Capacity_USDmn"] = "PHS/ASHF/C&S/Capacity (USDmn)";
    ColumnTitle["Market_profile"] = "Market Profile";
    ColumnTitle["Group_profile"] = "Group Profile";
    ColumnTitle["Fact_Sheet"] = "Fact Sheet";
    // first one only
    ColumnTitle["Market_security_Brief"] = "Market Security Brief";
    ColumnTitle["Reinsurance_Indicator"] = "Reinsurance Indicator";
    ColumnTitle["Status"] = "Status";
    ColumnTitle["Permitted_Use"] = "Permitted Use";
})(ColumnTitle || (ColumnTitle = {}));
export var AgGridColumns = function (isMarketStatus, onSelected, sortColumn, sortBy, apiLoading, handleSorting) {
    var appConfig = getApplicationConfig();
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var handleFavorite = function (event, index, InsuranceEntityId, Subscribe, favValue) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    event.stopPropagation();
                    if (favValue === undefined) {
                        alert("Market can't be added to favorite.");
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    if (!InsuranceEntityId) return [3 /*break*/, 3];
                    return [4 /*yield*/, enableMarketFavorite([{
                                Subscribe: Subscribe, InsuranceEntityId: InsuranceEntityId
                            }])];
                case 2:
                    _a.sent();
                    onSelected(index, true);
                    _a.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 6];
                case 5:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleSubscriptions = function (event, index, marketId, InsuranceEntityId, Subscribe) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    if (!marketId) return [3 /*break*/, 5];
                    return [4 /*yield*/, checkmarketSubscription(marketId)];
                case 2:
                    response = _a.sent();
                    if (!!response.data.value.length) return [3 /*break*/, 3];
                    alert("No news availlable for this market.");
                    return [2 /*return*/];
                case 3: return [4 /*yield*/, enableMarketNews([{
                            Subscribe: Subscribe, InsuranceEntityId: InsuranceEntityId
                        }])];
                case 4:
                    _a.sent();
                    onSelected(index, false);
                    _a.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    error_2 = _a.sent();
                    console.log(error_2);
                    return [3 /*break*/, 8];
                case 7:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var columns = [];
    var NameAndGroupCell = function (info) {
        var cellContentRef = useRef(null);
        useEffect(function () {
            if (cellContentRef.current && info.setTooltip) {
                var contentElement_1 = cellContentRef.current;
                var shouldDisplayTooltip = function () {
                    // return true
                    return contentElement_1.offsetWidth < contentElement_1.scrollWidth;
                };
                info.setTooltip(info.value, shouldDisplayTooltip);
            }
        }, [info.value, info.setTooltip]);
        var rowData = info.data;
        var navigationLink = "/market-details?MarketId=" + (rowData === null || rowData === void 0 ? void 0 : rowData.marketId);
        return (React.createElement(Link, { to: navigationLink, target: '_blank' },
            React.createElement("div", { ref: cellContentRef, className: 'text-ellipse' },
                React.createElement("span", { className: 'groupTextDecoration' }, info.getValue()),
                React.createElement("span", { style: { color: 'grey', display: "block" } }, rowData === null || rowData === void 0 ? void 0 : rowData.groupName))));
    };
    var BestRatingCell = function (info) {
        var rowData = info.data;
        return (React.createElement("div", { className: 'cell-height', style: { textAlign: "center" } },
            info.getValue(),
            React.createElement("div", { style: { color: 'grey' } },
                " ", rowData === null || rowData === void 0 ? void 0 :
                rowData.ratingOutlook)));
    };
    var SAndPRating = function (info) {
        var rowData = info.data;
        return (React.createElement("div", { className: 'cell-height', style: { textAlign: "center" } },
            info.getValue(),
            React.createElement("div", { style: { color: 'grey' } },
                " ", rowData === null || rowData === void 0 ? void 0 :
                rowData.sAndPRatingOutlook)));
    };
    var AMBestRatingExplaination = function (info) {
        var rowData = info.data;
        var displayFlag = !(rowData === null || rowData === void 0 ? void 0 : rowData.amBestId) && !(rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingExplanation) &&
            !(rowData === null || rowData === void 0 ? void 0 : rowData.sAndPId) && !(rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingExplanation);
        return (!displayFlag ? React.createElement(FontAwesomeIcon, { style: { marginTop: "8px" }, className: 'info-icon', icon: faCircleInfo }) : React.createElement(React.Fragment, null));
    };
    var SurplusValueCell = function (info) {
        var rowData = info.data;
        var AddLocalSeparator = function (no) {
            return no.toLocaleString(undefined, {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            });
        };
        return ((rowData === null || rowData === void 0 ? void 0 : rowData.keyFinancialAsOfDate) ?
            React.createElement(UuiFlexlayout, { alignItems: "flex-end", direction: 'column', className: 'cell-height' }, info.getValue() ?
                React.createElement(React.Fragment, null,
                    React.createElement("div", null, AddLocalSeparator(info.getValue())),
                    React.createElement("div", { style: { color: 'grey' } },
                        " ", rowData === null || rowData === void 0 ? void 0 :
                        rowData.keyFinancialAsOfDate))
                : null) : null);
    };
    var FactSheetDocCell = function (info) {
        var appInfo = useClientPageStore();
        var value = info.getValue();
        var errorStore = useErrorStore();
        var navigation = useNavigate();
        var DownLoadPDF = function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, appInfo.handlePdfDownload(value)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return value ? React.createElement("span", { onClick: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, DownLoadPDF(value)];
            }); }); } },
            React.createElement(FontAwesomeIcon, { style: { fontSize: "16px", color: "red", cursor: "pointer" }, icon: faFilePdf })) : null;
    };
    var MarketGuideStatus = function (info) {
        var val = info.getValue();
        var rowData = info.data;
        var doNotUseFlag = rowData === null || rowData === void 0 ? void 0 : rowData.doNotUseFlag;
        return (val === "Off" ?
            React.createElement("span", { style: { color: "red" } }, info.getValue()) :
            val === "Restricted" && doNotUseFlag ?
                React.createElement("span", { style: { color: "red" } }, "Do Not Use")
                :
                    React.createElement("span", null, info.getValue()));
    };
    var AdvisoryDocGuid = function (info) {
        var rowData = info.data;
        var advisoryFlagVal;
        ((rowData === null || rowData === void 0 ? void 0 : rowData.advisoryFlag) === true) ? advisoryFlagVal = "Yes" : advisoryFlagVal = "None";
        var clientStore = useClientPageStore();
        var isActive = advisoryFlagVal === "Yes" && (rowData === null || rowData === void 0 ? void 0 : rowData.advisoryDocGuid);
        var errorStore = useErrorStore();
        var navigation = useNavigate();
        var DownLoadPDF = function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, clientStore.handlePdfDownload(value)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: isActive ? 'groupTextDecoration' : "", onClick: isActive ? function () { return DownLoadPDF(rowData === null || rowData === void 0 ? void 0 : rowData.advisoryDocGuid); } : undefined }, advisoryFlagVal)));
    };
    var PermittedUse = function (info) { return (React.createElement("span", null, React.createElement(AonTooltip, { text: info.getValue(), width: 'md', darkMode: false, position: 'left', children: "".concat(info.getValue()) }))); };
    var FavoriteCell = function (info) {
        var rowData = info.data;
        var style = info.node.rowHeight === 30 ? { marginTop: "3px" } : { marginTop: "12px" };
        return (React.createElement("span", null,
            React.createElement(AonCheckbox, { style: style, disabled: isLoading, onClick: function (event) { return handleFavorite(event, info.node.rowIndex, rowData.InsuranceEntityId, !(rowData === null || rowData === void 0 ? void 0 : rowData.isFavorite), rowData === null || rowData === void 0 ? void 0 : rowData.isFavorite); }, checked: rowData === null || rowData === void 0 ? void 0 : rowData.isFavorite })));
    };
    var SubscribeCell = function (info) {
        var rowData = info.data;
        var style = info.node.rowHeight === 30 ? { marginTop: "3px" } : { marginTop: "12px" };
        return (React.createElement("span", null,
            React.createElement(AonCheckbox, { style: style, disabled: isLoading, onClick: function (event) { return handleSubscriptions(event, info.node.rowIndex, rowData.marketId, rowData.InsuranceEntityId, !(rowData === null || rowData === void 0 ? void 0 : rowData.isSubsribed)); }, checked: rowData === null || rowData === void 0 ? void 0 : rowData.isSubsribed })));
    };
    var MarketProfile = function (info) {
        var appInfo = useClientPageStore();
        var value = info.getValue();
        var errorStore = useErrorStore();
        var navigation = useNavigate();
        var DownLoadPDF = function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, appInfo.handlePdfDownload(value)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return (React.createElement(React.Fragment, null, value && React.createElement("div", { style: { color: "red" }, onClick: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, DownLoadPDF(value)];
            }); }); } },
            React.createElement(FontAwesomeIcon, { style: { fontSize: "18px", color: "#b00303", cursor: "pointer" }, icon: faFilePdf }))));
    };
    var GroupProfile = function (info) {
        var appInfo = useClientPageStore();
        var value = info.getValue();
        var errorStore = useErrorStore();
        var navigation = useNavigate();
        var DownLoadPDF = function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, appInfo.handlePdfDownload(value)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return (React.createElement(React.Fragment, null, value && React.createElement("span", { onClick: function () { return DownLoadPDF(value); } },
            React.createElement(FontAwesomeIcon, { style: { fontSize: "18px", color: "#b00303", cursor: "pointer" }, icon: faFilePdf }))));
    };
    var headerConfig = function (headerProps) {
        var classsName = sortColumn === headerProps.column.colId ? "sorting-".concat(sortBy, " active sorting-height") : "sorting sorting-height";
        return (React.createElement("div", { onClick: function () { return apiLoading ? null : handleSorting(headerProps.column.colId); }, className: classsName },
            React.createElement("span", null, headerProps.displayName)));
    };
    var CenterAlline = {
        display: "flex",
        justifyContent: "center"
    };
    if (appConfig.applicationId === 2) {
        if (!isMarketStatus) {
            //Review Ratings/Financials/Market Profiles options
            columns = [
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "isFavorite", cellRenderer: FavoriteCell, headerName: ColumnTitle.Favorite, sortable: false, flex: 0.5, minWidth: 100 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "isSubsribed", cellRenderer: SubscribeCell, headerName: ColumnTitle.News_subscription, sortable: false, flex: 0.5, minWidth: 130 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "marketId", headerName: ColumnTitle.Aon_ID, sortable: false, headerComponent: headerConfig, flex: 0.5, minWidth: 100 },
                { field: "name", headerName: ColumnTitle.Name_and_Group, cellRenderer: NameAndGroupCell, tooltipField: "name", tooltipComponent: "MarKetNameTooltip", sortable: false, headerComponent: headerConfig, flex: 2, minWidth: 150 },
                { field: "marketType", headerName: ColumnTitle.MARKET_TYPE, sortable: false, flex: 1, minWidth: 150 },
                { field: "countryName", headerName: ColumnTitle.Domiciled_Country, sortable: false, flex: 1, minWidth: 150 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "bestRating", headerName: ColumnTitle.AM_Best_Rating_and_Outlook, cellRenderer: BestRatingCell, sortable: false, flex: 0.5, minWidth: 130 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "sandPRating", headerName: ColumnTitle.S_and_P_Rating_and_Outlook, cellRenderer: SAndPRating, sortable: false, flex: 0.5, minWidth: 130 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "amBestRatingExplanation", tooltipComponent: "AdditionalInfoTooltip", tooltipField: "name", headerName: ColumnTitle.Additional_Rating_Information, cellRenderer: AMBestRatingExplaination, sortable: false, flex: 0.5, minWidth: 150 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "surplusValue", headerName: ColumnTitle.PHS_ASHF_C_and_S_Capacity_AuM_USDmn, cellRenderer: SurplusValueCell, sortable: false, flex: 0.5, minWidth: 180 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "marketProfile", tooltipComponent: "tooltipComponent", tooltipField: "marketProfileYearQuarter", headerName: ColumnTitle.Market_profile, cellRenderer: MarketProfile, sortable: false, flex: 0.5, minWidth: 100 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, tooltipComponent: "tooltipComponent", tooltipField: "groupProfileYearQuarter", field: "groupProfile", headerName: ColumnTitle.Group_profile, cellRenderer: GroupProfile, sortable: false, flex: 0.5, minWidth: 100 },
            ];
        }
        else {
            columns = [
                //Review Market Status
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "isFavorite", cellRenderer: FavoriteCell, headerName: ColumnTitle.Favorite, sortable: false, flex: 0.5, minWidth: 100 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "isSubsribed", cellRenderer: SubscribeCell, headerName: ColumnTitle.News_subscription, sortable: false, flex: 0.5, minWidth: 130 },
                { field: "name", headerName: ColumnTitle.Name_and_Group, cellRenderer: NameAndGroupCell, tooltipComponent: "MarKetNameTooltip", tooltipField: "name", sortable: false, headerComponent: headerConfig, flex: 2, minWidth: 160 },
                { field: "marketType", headerName: ColumnTitle.MARKET_TYPE, sortable: false, flex: 1, minWidth: 130 },
                { field: "countryName", headerName: ColumnTitle.Domiciled_Country, sortable: false, flex: 1, minWidth: 130 },
                { field: "marketGuideStatus", headerName: ColumnTitle.Status, cellRenderer: MarketGuideStatus, sortable: false, flex: 1, minWidth: 120, },
                { field: "reinsuranceIndicator", headerName: ColumnTitle.Reinsurance_Indicator, sortable: false, flex: 1, minWidth: 150 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "advisoryDocGuid", headerName: ColumnTitle.Market_security_Brief, cellRenderer: AdvisoryDocGuid, sortable: false, flex: 1, minWidth: 120, },
                { field: "permittedUse", headerName: ColumnTitle.Permitted_Use, cellRenderer: PermittedUse, sortable: false, flex: 2, minWidth: 200 },
            ];
        }
    }
    else if (appConfig.applicationId === 3) {
        //Guide Ratings/Financials/Market Profiles options
        if (!isMarketStatus) {
            columns = [
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "marketId", headerName: ColumnTitle.Aon_ID, sortable: false, headerComponent: headerConfig, flex: 0.5, minWidth: 150 },
                { field: "name", headerName: ColumnTitle.Name_and_Group, cellRenderer: NameAndGroupCell, tooltipComponent: "MarKetNameTooltip", tooltipField: "name", sortable: false, headerComponent: headerConfig, flex: 2, minWidth: 150 },
                { field: "marketType", headerName: ColumnTitle.MARKET_TYPE, sortable: false, flex: 1, minWidth: 150 },
                { field: "countryName", headerName: ColumnTitle.Domiciled_Country, sortable: false, flex: 1, minWidth: 150 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "bestRating", headerName: ColumnTitle.AM_Best_Rating_and_Outlook, cellRenderer: BestRatingCell, sortable: false, flex: 0.5, minWidth: 150 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "sandPRating", headerName: ColumnTitle.S_and_P_Rating_and_Outlook, cellRenderer: SAndPRating, sortable: false, flex: 0.5, minWidth: 150 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "amBestRatingExplanation", headerName: ColumnTitle.Additional_Rating_Information, tooltipComponent: "AdditionalInfoTooltip", tooltipField: "name", cellRenderer: AMBestRatingExplaination, sortable: false, flex: 0.5, minWidth: 150 },
                { field: "surplusValue", headerName: ColumnTitle.PHS_ASHF_C_and_S_Capacity_USDmn, cellRenderer: SurplusValueCell, sortable: false, flex: 0.5, minWidth: 180 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, tooltipComponent: "tooltipComponent", tooltipField: "factSheetDate", field: "factSheetDocumentGuid", headerName: ColumnTitle.Fact_Sheet, cellRenderer: FactSheetDocCell, sortable: false, flex: 0.5, minWidth: 150 },
            ];
        }
        else {
            columns = [
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "marketId", headerName: ColumnTitle.Aon_ID, sortable: false, headerComponent: headerConfig, flex: 0.5, minWidth: 150 },
                { field: "name", headerName: ColumnTitle.Name_and_Group, cellRenderer: NameAndGroupCell, tooltipComponent: "MarKetNameTooltip", tooltipField: "name", sortable: false, headerComponent: headerConfig, flex: 2.5, minWidth: 150 },
                { field: "marketType", headerName: ColumnTitle.MARKET_TYPE, sortable: false, flex: 1, minWidth: 120 },
                { field: "countryName", headerName: ColumnTitle.Domiciled_Country, sortable: false, flex: 1, minWidth: 120 },
                { field: "marketGuideStatus", headerName: ColumnTitle.Status, cellRenderer: MarketGuideStatus, sortable: false, flex: 1, minWidth: 100 },
                { field: "reinsuranceIndicator", headerName: ColumnTitle.Reinsurance_Indicator, sortable: false, flex: 1, minWidth: 150 },
                { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "advisoryDocGuid", headerName: ColumnTitle.Market_security_Brief, cellRenderer: AdvisoryDocGuid, sortable: false, flex: 1, minWidth: 100 },
                { field: "permittedUse", headerName: ColumnTitle.Permitted_Use, cellRenderer: PermittedUse, sortable: false, flex: 2, minWidth: 150 },
            ];
        }
    }
    else if (appConfig.applicationId === 1) {
        columns = [
            { field: "marketId", headerClass: "grid-header-center", cellStyle: CenterAlline, headerName: ColumnTitle.Aon_ID, sortable: false, headerComponent: headerConfig, flex: 0.5, minWidth: 150 },
            { field: "name", headerName: ColumnTitle.Name_and_Group, cellRenderer: NameAndGroupCell, tooltipComponent: "MarKetNameTooltip", tooltipField: "name", sortable: false, headerComponent: headerConfig, flex: 2, minWidth: 150 },
            { field: "marketTypeName", headerName: ColumnTitle.MARKET_TYPE, sortable: false, flex: 1, minWidth: 120 },
            { field: "countryName", headerName: ColumnTitle.Domiciled_Country, sortable: false, flex: 1, minWidth: 150 },
            { field: "bestRating", headerName: ColumnTitle.AM_Best_Rating_and_Outlook, cellRenderer: BestRatingCell, sortable: false, flex: 0.5, minWidth: 150 },
            { field: "sandPRating", headerName: ColumnTitle.S_and_P_Rating_and_Outlook, cellRenderer: SAndPRating, sortable: false, flex: 0.5, minWidth: 150 },
            { field: "amBestRatingExplanation", headerClass: "grid-header-center", cellStyle: CenterAlline, headerName: ColumnTitle.Additional_Rating_Information, tooltipComponent: "AdditionalInfoTooltip", tooltipField: "name", cellRenderer: AMBestRatingExplaination, sortable: false, flex: 0.5, minWidth: 150 },
            { field: "surplusValue", headerName: ColumnTitle.PHS_ASHF_C_and_S_Capacity_AuM_USDmn, cellRenderer: SurplusValueCell, sortable: false, flex: 0.5, minWidth: 180 },
            { field: "factSheetDocumentGuid", headerClass: "grid-header-center", cellStyle: CenterAlline, headerName: ColumnTitle.Fact_Sheet, tooltipField: "factSheetDate", tooltipComponent: "tooltipComponent", cellRenderer: FactSheetDocCell, sortable: false, flex: 0.5, minWidth: 150 },
        ];
    }
    return columns;
};
export var GetRowHeight = function (params) {
    if ((params.data.groupName && params.data.name) || params.data.keyFinancialAsOfDate) {
        return 50;
    }
    else {
        return 30;
    }
};
